import type { PopulatedWine } from './types';

interface WineQuickInfoProps {
  wine: PopulatedWine;
}

interface SpecItemProps {
  label: string;
  value: string;
}

const SpecItem = ({ label, value }: SpecItemProps) => (
  <div>
    <dt className="font-sans text-xs font-semibold uppercase tracking-widest text-gray-500 mb-1">
      {label}
    </dt>
    <dd className="font-sans text-lg font-medium text-gray-900">
      {value}
    </dd>
  </div>
);

export const WineQuickInfo = ({ wine }: WineQuickInfoProps) => {
  const specs: Array<{ label: string; value: string } | null> = [
    wine.price ? { label: 'Price', value: `$${wine.price.toFixed(2)}` } : null,
    wine.volume ? { label: 'Volume', value: `${wine.volume} ml` } : null,
    wine.alcoholContent ? { label: 'ABV', value: `${wine.alcoholContent}%` } : null,
    wine.varietal ? { label: 'Varietal', value: wine.varietal } : null,
    wine.grapes ? { label: 'Grapes', value: wine.grapes } : null,
    wine.appellationNotes ? { label: 'Appellation', value: wine.appellationNotes } : null,
    wine.allergens ? { label: 'Allergens', value: wine.allergens } : null,
  ];
  const activeSpecs = specs.filter((s): s is { label: string; value: string } => s !== null);

  if (activeSpecs.length === 0) {
    return (
      <section>
        <h2 className="font-sans text-xs font-semibold uppercase tracking-widest text-gray-500 mb-4">
          Specifications
        </h2>
        <p className="font-sans text-base text-gray-500 italic">
          No additional wine information available
        </p>
      </section>
    );
  }

  return (
    <section>
      <h2 className="font-sans text-xs font-semibold uppercase tracking-widest text-gray-500 mb-6">
        Specifications
      </h2>
      <dl className="grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-6">
        {activeSpecs.map((spec) => (
          <SpecItem key={spec.label} label={spec.label} value={spec.value} />
        ))}
      </dl>
    </section>
  );
};
